import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";

export enum ApiTemplateType {
  email = "email",
  messenger = "messenger",
}

export interface ApiTemplate {
  id: number;
  title: string;
  subject: string | null;
  body: string;
  is_private: boolean;
  owner: ApiEmployeeShort;
  template_type: ApiTemplateType;
  can_edit: boolean;
}

export interface ApiTemplateSavePayload {
  title: string;
  subject: string | null;
  body: string;
  is_private: boolean;
  template_type: ApiTemplateType;
}

export enum ApiTemplateVisibility {
  public = "public",
  private = "private",
}

export interface ApiTemplateCompiled {
  subject: string | null;
  body: string;
}
